import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import './Gacha.css'
import GachaRank1Info from './GachaRank1Info'
import GachaRank2Info from './GachaRank2Info'
import GachaRank3Info from './GachaRank3Info'
import GachaRank9Info from './GachaRank9Info'
import { useTranslation } from "react-i18next";
import { getAssetUrl } from '../../../../utils/assetUtils';

const Preview = ({}) => {
    const { t } = useTranslation();

    const {id} = useParams();
    const {shop} = useParams();

    const [packageInfo, setPackageInfo] = useState({
        id: 0,
        type: 0,
        price: 0,
        stock: 0,
        number: 0,
        img_path: '',
        image_url: '',
        pop_image_url: '',
        name: '',
        description: '',
        is_psa_enabled: false,
        psa: 0,
    })
    const [cardList, setCardList] = useState([]);
  


    useEffect(() => {
        // packagecard list
        fetch(`${process.env.REACT_APP_API_URL}/api/package/preview/${id}`, {
            method: 'GET',
            headers: {
            },
            credentials: 'include',
        })
        .then(response => response.json())
        .then(data => {
            if(!data.errors) {
                setPackageInfo(data.package);
                setCardList(data.package.package_cards);
                import('../../../../theme/pattern-' + data.design_pattern + '.css');
            } else {
                alert(Object.values(data.errors)[0]);
            }
        })
    }, []);



    return (
        <>
            <div className="gacha">
                <div className="gacha-package">
                    <div className="gacha-package-image">
                        {packageInfo.image_url && (
                            <img src={getAssetUrl(packageInfo.image_url)} alt="package" />
                        )}
                        <div className="require-pt">
                            <div className="require-pt-icon">
                                <img src="/img/balance.svg" alt="pt" />
                            </div>
                            <div className="require-pt-value">{packageInfo.price.toLocaleString()}</div>
                        </div>
                    </div>
                </div>
                <div className="stock-gacha">
                    {!packageInfo.hidden_from || packageInfo.stock == 0 || packageInfo.stock > packageInfo.hidden_from ? (
                        <>
                            <div className="stock-seek-bar">
                                <div 
                                    className={
                                        packageInfo.stock / packageInfo.number * 100 < 25 ? 'stock-seek-bar-inner stock-seek-bar-inner-25-percent' :
                                        packageInfo.stock / packageInfo.number * 100 < 50 ? 'stock-seek-bar-inner stock-seek-bar-inner-50-percent' :
                                        packageInfo.stock / packageInfo.number * 100 < 75 ? 'stock-seek-bar-inner stock-seek-bar-inner-75-percent' :
                                        'stock-seek-bar-inner stock-seek-bar-inner-75-percent'
                                    }
                                    style={{ width: (packageInfo.stock / packageInfo.number * 100 > 99 ? 99 : packageInfo.stock / packageInfo.number * 100)+'%' }}>
                                </div>
                            </div>
                            <div className="stock-value">
                                {t('preview.rest')} <span className="stock-now-text">{packageInfo.stock.toLocaleString()}</span>/<span className="stock-total-text">{packageInfo.number.toLocaleString()}</span>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="stock-seek-bar">
                                <div className="stock-seek-bar-inner stock-seek-bar-inner-rainbow"></div>
                            </div>
                            <div className="stock-value">
                                {t('preview.rest')} <span className="stock-now-text">???</span>/<span className="stock-total-text">{packageInfo.number.toLocaleString()}</span>
                            </div>
                        </>
                    )}

                </div>
                <div className="gacha-button">
                    <button className="gacha-button-1" >{t('preview.gacha1')}</button>
                    <button className="gacha-button-10" >{t('preview.gacha10')}</button>
                </div>
                <div className="gacha-info" {...(packageInfo.pop_image_url && {
                    style: {
                        padding: '0px',
                    }
                })}>
                    {packageInfo.pop_image_url ? (
                        <div className="gacha-info-detail-image">
                            <img src={getAssetUrl(packageInfo.pop_image_url)} alt="pop" />
                        </div>
                    ) : (
                    <>
                        {cardList.filter(card => card.rank === 1).length > 0 && (
                            <div className="gacha-info-detail">
                                <div className="gacha-info-rank-image">
                                    <img src="/img/rank1.png" alt="rank" />
                                </div>
                                <div className="gacha-info-card-images">
                                    <GachaRank1Info
                                        cards={
                                            cardList.filter(card => card.rank === 1)
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        {cardList.filter(card => card.rank === 2).length > 0 && (
                            <div className="gacha-info-detail">
                                <div className="gacha-info-rank-image">
                                    <img src="/img/rank2.png" alt="rank" />
                                </div>
                                <div className="gacha-info-card-images">
                                    <GachaRank2Info
                                        cards={
                                            cardList.filter(card => card.rank === 2)
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        {cardList.filter(card => card.rank === 3).length > 0 && (
                            <div className="gacha-info-detail">
                                <div className="gacha-info-rank-image">
                                    <img src="/img/rank3.png" alt="rank" />
                                </div>
                                <div className="gacha-info-card-images">
                                    <GachaRank3Info
                                        cards={
                                            cardList.filter(card => card.rank === 3)
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        {cardList.filter(card => card.rank === 9).length > 0 && (
                            <div className="gacha-info-detail">
                                <div className="gacha-info-rank-image">
                                    <img src="/img/rank-last.png" alt="rank" />
                                </div>
                                <div className="gacha-info-card-images">
                                    <GachaRank9Info
                                        cards={
                                            cardList.filter(card => card.rank === 9)
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        {cardList.filter(card => card.rank === 4).length > 0 && (
                            <div className="gacha-info-detail">
                                {t('preview.detail')}                            
                                <div className="gacha-info-card-images">
                                    {!packageInfo.display_fourth_rank &&
                                        <span class="gacha-info-note-preview">({t('preview.preview')})</span>
                                    }
                                    <GachaRank3Info
                                        cards={
                                            cardList.filter(card => card.rank === 4)
                                        }
                                    />
                                </div>
                            </div>
                        )}
                    </>
                    )}
                </div>
                <div className="gacha-info-note">
                    <div className='gacha-info-note-title'>{t('preview.title')}</div>
                    <div className='gacha-info-note-text'>
                        {t('preview.text1')}<br />
                        {t('preview.text2')}<br />
                        {t('preview.text3')}<br />
                    </div>
                </div>
                <div className="gacha-button">
                    <button className="gacha-button-1" >{t('preview.gacha1')}</button>
                    <button className="gacha-button-10" >{t('preview.gacha10')}</button>
                </div>
            </div>
        </>
    )
}

export default Preview
